var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBurgerDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 10.6665C5.92996 10.6665 5.33301 11.2635 5.33301 11.9998C5.33301 12.7362 5.92996 13.3332 6.66634 13.3332H25.333C26.0694 13.3332 26.6663 12.7362 26.6663 11.9998C26.6663 11.2635 26.0694 10.6665 25.333 10.6665H6.66634Z",
    fill: "white",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 18.6665C5.92996 18.6665 5.33301 19.2635 5.33301 19.9998C5.33301 20.7362 5.92996 21.3332 6.66634 21.3332H25.333C26.0694 21.3332 26.6663 20.7362 26.6663 19.9998C26.6663 19.2635 26.0694 18.6665 25.333 18.6665H6.66634Z",
    fill: "white",
    fillOpacity: 0.85
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerDark);
export default __webpack_public_path__ + "static/media/burgerDark.405ed955e88376adcb9a07b06d31887b.svg";
export { ForwardRef as ReactComponent };